import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import api from "@/lib/api";
import { ProjectCard } from "@/components/ProjectCard";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Projects() {
  const [params] = useSearchParams();
  const [projects, setProjects] = useState([]);
  const [q, setQ] = useState(params.get("q") || "");
  const [approval, setApproval] = useState("all");
  const [budget, setBudget] = useState("all");

  const fetchProjects = () => {
    const p = {};
    if (q) p.q = q;
    if (approval !== "all") p.approval = approval;
    if (budget !== "all") p.max_price = Number(budget);
    api.get("/projects", { params: p }).then((r) => setProjects(r.data));
  };

  useEffect(() => { fetchProjects(); /* eslint-disable-next-line */ }, [approval, budget]);

  return (
    <div className="font-body">
      <div className="bg-[#08341f] py-16 text-center text-white">
        <p className="text-sm uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">Our Projects</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-bold mt-3">Premium Open Plots in Prime Locations</h1>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 -mt-8">
        <div className="bg-white rounded-2xl shadow-[0_16px_48px_rgba(11,93,59,0.12)] p-4 md:p-5 grid grid-cols-1 md:grid-cols-4 gap-3" data-testid="project-filters">
          <div className="md:col-span-2 flex items-center gap-2 px-4 rounded-xl bg-gray-50 border border-gray-100">
            <Search size={18} className="text-[#0B5D3B]" />
            <input data-testid="projects-search" value={q} onChange={(e)=>setQ(e.target.value)} onKeyDown={(e)=>e.key==="Enter"&&fetchProjects()} placeholder="Location or project name…" className="w-full py-3 bg-transparent outline-none text-sm" />
          </div>
          <Select value={approval} onValueChange={setApproval}>
            <SelectTrigger data-testid="filter-approval" className="h-[46px] rounded-xl"><SelectValue placeholder="Approval" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Approvals</SelectItem>
              <SelectItem value="HMDA">HMDA</SelectItem>
              <SelectItem value="DTCP">DTCP</SelectItem>
              <SelectItem value="FCDA">FCDA</SelectItem>
            </SelectContent>
          </Select>
          <Select value={budget} onValueChange={setBudget}>
            <SelectTrigger data-testid="filter-budget" className="h-[46px] rounded-xl"><SelectValue placeholder="Budget" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Any Budget</SelectItem>
              <SelectItem value="10000">Under ₹10,000/sq.yd</SelectItem>
              <SelectItem value="15000">Under ₹15,000/sq.yd</SelectItem>
              <SelectItem value="20000">Under ₹20,000/sq.yd</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
        {projects.length === 0 ? (
          <p className="text-center text-gray-500 py-20">No projects match your search. Try adjusting the filters.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {projects.map((p, i) => <ProjectCard key={p.id} p={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
